<template lang="pug">
include TrainerLevel.pug
</template>

<script type="text/javascript">
import { has, each, isEmpty } from 'underscore'

export default {
  name: "TrainerLevel",
  props: ["trainer"],
  data() {
    return {
      noLevelChar: "~"
    }
  },
  computed: {
    points() {
      const value = this.trainer
      if (!has(value, "courses")) return this.noLevelChar

      // check courses por model (v1 and after v2)
      const courses = value.courses
      const courses_v2 = value.courses_v2

      const levelV1 = this.extractV1Level(courses)
      if (levelV1) return levelV1

      const levelV2 = this.extractV2Level(courses_v2)
      if (levelV2) return levelV2

      return this.noLevelChar
    }
  },
  methods: {
    extractV2Level(courses_v2) {
      let level = null
      each(courses_v2, course => {
        if (!isEmpty(course.level)) level = course.level
      })
      return level
    },
    extractV1Level(courses) {
      let level = null
      each(courses, course => {
        if (course.level && !level) level = course.level
      })
      return level
    },
  },
}
</script>

<style scoped lang="scss">
@import '../variables';
@import '../variables_colreps';
@import '../variables_mexreps';

.nivel {
  margin-top: 1.2rem;
  width: 100%;
  background-color: $color-white;
  display: inline-block;
  text-align: center;
  padding: 0.5rem 0;

  .nivel-number {
    font-size: 2.5rem;
    font-weight: bold;
    display: block;
    line-height: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TrainerLevel.vue